/**
 * Method: initGallery
 *
 * Requires html structure to be
 * .gallery-grid > .content-item(multiple) > img
 *
 * @return void
 */
import * as bootstrap from 'bootstrap';
export function initGallery() {
  if (!$('#carouselGallery').length) {
    return false;
  }
  var carousel = new bootstrap.Carousel('#carouselGallery');
  calculateImages($(this));

  $(window).on('load resize', function () {
    $('.gallery-grid').each(function () {
      calculateImages($(this));
      $('.content-item img', this).css('opacity', '100');
      $(this).removeClass('ph-cc');
    });
  });

  $('.gallery-wrapper').hide();
  $('.gallery-grid .content-item, .carousel-back').css('cursor', 'pointer');

  $(document).on(
    'click',
    '.gallery-grid .content-item, .gallery-grid-mobile .content-item',
    function (e) {
      e.preventDefault();
      $('.gallery-grid, .gallery-grid-mobile').hide();
      $('.gallery-wrapper').show();
      carousel.to($(this).data('index'));
      $('#carouselGallery').addClass('slide');
    }
  );

  $(document).on('click', '.carousel-back', function (e) {
    $('.gallery-wrapper').hide();
    $('.gallery-grid, .gallery-grid-mobile').show();
    $('#carouselGallery').removeClass('slide');
  });
}

function calculateImages(gallery) {
  var imageCount = 0;
  var relativeWidths = [];
  var sumRelativeWidth = 0;
  var gutter = (14 / $('.gallery-grid').width()) * 100;

  gallery.find('img').each(function () {
    var relativeW = $(this).width() / $(this).height();
    relativeWidths.push(relativeW);
    sumRelativeWidth += relativeW;
    imageCount += 1;
  });

  var percentageDiv = (100 - gutter * imageCount) / sumRelativeWidth;

  gallery.find('.content-item').each(function (i) {
    var relativeW = relativeWidths[i];
    var contentItem = $(this);
    var finalWidth = Math.floor(relativeW * percentageDiv * 100) / 100;
    contentItem.width(finalWidth + '%');

    // first item only half gutter
    if (i > 0) {
      contentItem.css('margin-left', gutter + '%');
    } else {
      contentItem.css('margin-left', gutter / 2 + '%');
    }
  });
}

function showImages(el) {
  var windowHeight = jQuery(window).height();
  $(el).each(function () {
    var thisPos = $(this).offset().top;

    var topOfWindow = $(window).scrollTop();
    if (topOfWindow + windowHeight - 100 > thisPos) {
      $(this).addClass('fadeIn');
    }
  });
}

// if the image in the window of browser when the page is loaded, show that image
$(document).ready(function () {
  showImages('img');
});

// if the image in the window of browser when scrolling the page, show that image
$(window).scroll(function () {
  showImages('img');
});
